import * as Core from './core';

type stringOption = string | undefined;

export interface MockEmail {
    to: string;
    body: string;
}

const prefix = '';
// const postFile = (path: string, params: object) => Core.uploadFile('POST', prefix + path, params);
// const putFile = (path: string, params: object) => Core.uploadFile('PUT', prefix + path, params);
// const patchFile = (path: string, params: object) => Core.uploadFile('PATCH', prefix + path, params);

const post = (path: string, params?: object, ignore403?: boolean) => Core.simpleRequest('POST', prefix + path, params, ignore403);
// const patch = (path: string, params?: object, ignore403?: boolean) => Core.simpleRequest('PATCH', prefix + path, params, ignore403);
// const put = (path: string, params?: object, ignore403?: boolean) => Core.simpleRequest('PUT', prefix + path, params, ignore403);

const get = (path: string, params?: object, ignore403?: boolean) => Core.get(prefix + path, params, ignore403);
// const del = (path: string, params?: object, ignore403?: boolean) => Core.del(prefix + path, params, ignore403);

// const postFileJson = async (path: string, params: object) => (await postFile(path, params)).json();
// const putFileJson = async (path: string, params: object) => (await putFile(path, params)).json();
// const patchFileJson = async (path: string, params: object) => (await patchFile(path, params)).json();

// const postJson = async (path: string, params?: object, ignore403?: boolean) => (await post(path, params, ignore403)).json();
// const patchJson = async (path: string, params?: object, ignore403?: boolean) => (await patch(path, params, ignore403)).json();
// const putJson = async (path: string, params?: object, ignore403?: boolean) => (await put(path, params, ignore403)).json();

const getJson = async (path: string, params?: object, ignore403?: boolean) => (await get(path, params, ignore403)).json();
// const delJson = async (path: string, params?: object, ignore403?: boolean) => (await del(path, params, ignore403)).json();

export const resetPassword = (body: object) =>  post('/reset-password', body);
export const resetPassword2 = (body: object) => post('/reset-password2', body);
export const resetPassword3 = (body: object) => post('/reset-password3', body, true);
export const remindConsultants = () => post('/reminders/consultants');
export const remindClients = () => post('/reminders/clients');
export const mail = (to: string, subject: string, body: string, cc?: string) => post('/mail', Core.filterVals({to, subject, body, cc}));
// TODO: remove mailSpecial
export const mailSpecial = (url: string, from: stringOption, to: string, subject: string, body: string, cc?: string) => post(url, Core.filterVals({from, to, subject, body, cc}));
export const getSortedZones = () => getJson('/sorted-zones');
export const logout = () => post('/logout', {}, true);
export const sessionStatus = () => get('/session-status', {}, true);
export const login = (body: object) =>  post('/login', body);
export const mailsTest = () => getJson('/mail/test') as Promise<MockEmail[]>;
export const mailTest = async (to: string) => (await mailsTest()).find(e => e.to === to);

export interface FileData {
    'bucket-name': string;
    'content-type': string;
    key: string;
    filename: string;
    size: number;
}

export const fileData: FileData = {
    'bucket-name': '',
    'content-type': '',
    key: '',
    filename: '',
    size: 0
};

export const s3Href = (f: FileData) => {
    const searchParams = new URLSearchParams();
    searchParams.set('key', f.key);
    searchParams.set('content-type', f['content-type']);
    searchParams.set('filename', f.filename);
    searchParams.set('size', f.size + '');
    searchParams.set('bucket-name', f['bucket-name']);

    return Core.backend + '/file?' + searchParams.toString();
};
export const profilePic = (f: FileData) => {
    const pref = f['bucket-name'] === 'korum-frontend' ? 'https://axceller.com' : 'https://stg.axceller.com';
    return pref + '/' + f.key;
};

export const questionnaireHref = (firstName: string, lastName: string, email: string) => {
    const pref = location.href.split('#')[0];
    return Core.href(`${pref}#/registerConsultant`, {firstName, lastName, email});
};



// WEBPACK FOOTER //
// ./src/client/Home.tsx